import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon, Button, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  SemanticTable,
  ContainerInputSearch,
  Input,
} from "./styles";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";

import { isAuthAdmin } from "../../../services/auth";

const ListarCertificados = (props) => {
  const [certificados, setCertificados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadAuth();
    loadCertificado();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadCertificado = async () => {
    await api
      .get(`certificado_by_gerador?`)
      .then(async (res) => {
        let logs = { local: "certificado", texto: `listou os certificados` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setCertificados(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os Certificados", err, "error");
        setLoading(false);
      });
  };
  const verifyAluno = (value) => {
    if (value == "") {
      return "não existe aluno";
    } else {
      return value;
    }
  };
  const modifyDate = (date) => {
    const newDate = date.split("T");
    return newDate[0];
  };
  const verifyAutor = (autor) => {
    if (autor != null) {
      return autor.nome;
    } else {
      return "autor não existe";
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Lista de certificados gerados</Title>
            <ContainerInputSearch>
              <Input
                type="text"
                placeholder="Pesquise pelo titulo"
                onChange={(e) => setSearch(e.target.value)}
              />
            </ContainerInputSearch>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Aluno</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Data</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Email</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    Criado por
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Arquivo</SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              {certificados.length > 0 ? (
                <SemanticTable.Body>
                  {certificados
                    .reverse()
                    .filter((certificado) =>
                      verifyAluno(certificado.aluno)
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    )
                    .map((certificado, index) => (
                      <SemanticTable.Row>
                        <SemanticTable.Cell>
                          {certificado.aluno}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {modifyDate(certificado.data)}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {certificado.email}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {verifyAutor(certificado.autor)}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {certificado.link}
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))}
                </SemanticTable.Body>
              ) : (
                <h3>Nenhum certificado encontrado</h3>
              )}
            </SemanticTable>
          </Content>
        )}
        ;
      </Container>
    </>
  );
};

export default withRouter(ListarCertificados);
